import { render, staticRenderFns } from "./classInfo.vue?vue&type=template&id=0e3b7150&scoped=true"
import script from "./classInfo.vue?vue&type=script&lang=js"
export * from "./classInfo.vue?vue&type=script&lang=js"
import style0 from "./classInfo.vue?vue&type=style&index=0&id=0e3b7150&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3b7150",
  null
  
)

export default component.exports